import type { MRT_ColumnDef } from 'material-react-table';
import { useMemo, } from 'react';
import { Contrato, Saldo } from '@/shared/interfaces';
import { EstadoComponente } from '@/shared/components/ui';
import { EstadoSaldoChoiceEnum } from '@/shared';
import { ViewClienteRubroInfoTableCell } from '../components/tables/rubros';

type UseColumnsTransaccionesClienteProps = {
  contract: Contrato;
};

export const useColumnsSaldo = ({
  contract,
}: UseColumnsTransaccionesClienteProps) => {

  const fnEstadoSaldo = (estado_saldo: string): { color: string, texto: string } => {
    switch (estado_saldo) {
      case EstadoSaldoChoiceEnum.FACTURADO:
        return {
          color: 'green',
          texto: 'FACTURADO'
        };
      case EstadoSaldoChoiceEnum.NO_FACTURADO:
        return {
          color: "orange",
          texto: 'NO FACTURADO'
        };
      default:
        return {
          color: "blue",
          texto: estado_saldo
        };
    }
  }

  ///* local state -----------------------

  ///* columns -----------------------
  const columnsSaldo = useMemo<MRT_ColumnDef<Saldo>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'N° Referencia',
        size: 222,
      },
      {
        accessorKey: 'fecha_pago',
        header: 'Fecha Pago',
        size: 200,
      },
      {
        accessorKey: 'valor_total',
        header: 'Valor Total',
        size: 100,
      },
      {
        accessorKey: 'estado_saldo',
        header: 'Estado Saldo',
        size: 200,
        Cell: ({ row }) => (
          <EstadoComponente backgroundColor={fnEstadoSaldo(row.original.estado_saldo).color}
            texto={fnEstadoSaldo(row.original.estado_saldo).texto} />
        )
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripcion',
        size: 200,
      },
      {
        accessorKey: 'rubro_origen',
        header: 'Rubro Origen',
        size: 200,
        Cell: ({ row }) => {
          if(!row.original.rubro_origen_data) return 'N/A';

          return (
            <ViewClienteRubroInfoTableCell
              rubro={row.original.rubro_origen_data!}
              contract={contract!}
            />
          );
        },
      },
      {
        accessorKey: 'rubro_destino',
        header: 'Rubro Destino',
        size: 200,
        Cell: ({ row }) => {

          if(!row.original.rubro_destino_data) return 'N/A';

          return (
            <ViewClienteRubroInfoTableCell
              rubro={row.original.rubro_destino_data!}
              contract={contract!}
            />
          );
        },
      },
    ],
    []
  );

  return { columnsSaldo };
};
